import { RelatedRecordWidgetFieldRef } from './types'

export function getSupportedTargetFields(fields: FieldDto[]) {
    return fields.filter((f) => {
        return ['lookup', 'multi_lookup'].includes(f.type)
    })
}

export function getSupportedProfileImageFields(fields: FieldDto[]) {
    return fields.filter((f) => f.type === 'multi_file')
}

export function getSupportedTitleFields(fields: FieldDto[]) {
    return fields.filter((f) => {
        return ['string', 'long_text', 'document'].includes(f.type)
    })
}

export function getSupportedSubtitleFields(fields: FieldDto[]) {
    return fields.filter((f) => {
        return ['string', 'long_text', 'document'].includes(f.type)
    })
}

export function getSupportedDescriptionFields(fields: FieldDto[]) {
    return fields.filter((f) => {
        return ['string', 'long_text', 'document'].includes(f.type)
    })
}

export function getFieldRef(field?: FieldDto): RelatedRecordWidgetFieldRef | undefined {
    if (!field) return undefined

    return {
        type: 'field',
        fieldSid: field._sid,
        fieldApiName: field.api_name,
    }
}
